<template>
  <div>
    <div v-if="despachod">
      <div
        style="z-index: 1000 !important"
        class="floated-colors-btn second-floated-btn"
        @click="cambiarUiTabla"
      >
        <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
          <div class="os-toggler-i">
            <div class="os-toggler-pill"></div>
          </div>
        </div>
        <span v-if="!cambiar_UiTabla">Tabla Detalle</span>
        <span v-if="cambiar_UiTabla">Tabla Resumen</span>
      </div>
      <div class="row mt-2">
        <div class="col-lg-12">
          <div class="padded-lg">
            <!--START - Projects list-->
            <div v-if="!cambiar_UiTabla" class="projects-list">
              <div
                class="project-box"
                v-for="detalle in despachod"
                :key="detalle.id"
                @click="abrirModalRetornar(detalle)"
                v-bind:style="
                  despachoe.estado == '9'
                    ? 'background-color: #f7cdcd;'
                    : detalle.cant_asignada_estacion > 0 &&
                      detalle.cant_enviada == 0
                    ? 'background-color: #FFFF;'
                    : detalle.cant_asignada_estacion == detalle.cant_enviada &&
                      detalle.cant_enviada > 0
                    ? 'background-color: #d3ffbf;'
                    : detalle.cant_asignada_estacion > detalle.cant_enviada &&
                      detalle.cant_enviada > 0
                    ? 'background-color: #FEEBB9;'
                    : detalle.cant_enviada == 0 &&
                      detalle.cant_asignada_estacion > 0
                    ? 'background-color: #FFFFF;'
                    : detalle.cant_asignada_estacion == 0
                    ? 'background-color: #f7cdcd;'
                    : 'color: #929292;'
                "
              >
                <div
                  class="project-head"
                  style="padding-rigth: 1em; padding-left: 1em"
                >
                  <div class="project-title">
                    <h5>
                      {{ detalle.producto_id }}
                    </h5>
                    <small>{{ detalle.producto_nombre }}</small>
                  </div>
                  <div
                    class="badge badge-info form-inline justify-content-sm-end"
                    v-if="detalle.producto_id"
                  >
                    {{ detalle.categoria_nombre }}
                  </div>
                </div>
                <div class="project-info">
                  <div class="row align-items-center">
                    <div class="col-sm-5">
                      <div class="row">
                        <div class="col-6">
                          <div class="el-tablo highlight">
                            <div class="label">ESTACIONADA</div>
                            <h5 style="color: DodgerBlue">
                              {{ detalle.cant_asignada_estacion }}
                            </h5>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="el-tablo highlight">
                            <div class="label">DESPACHADA</div>
                            <h5
                              v-if="
                                parseFloat(detalle.cant_asignada_estacion) ==
                                  0 ||
                                parseFloat(detalle.cant_asignada_estacion) >
                                  parseFloat(detalle.cant_enviada)
                              "
                              style="color: Orange"
                            >
                              {{ detalle.cant_enviada }}
                            </h5>
                            <h5
                              v-if="
                                detalle.cant_asignada_estacion != 0 &&
                                detalle.cant_enviada ==
                                  detalle.cant_asignada_estacion
                              "
                              style="color: LimeGreen"
                            >
                              {{ detalle.cant_enviada }}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 offset-sm-1">
                      <div class="os-progress-bar primary">
                        <div class="bar-labels">
                          <div class="bar-label-left">
                            <span>Despacho a Cliente:</span>
                          </div>
                          <div class="bar-label-right col-8">
                            <div class="progress">
                              <div
                                v-if="
                                  detalle.cant_enviada &&
                                  detalle.cant_asignada_estacion
                                "
                                class="
                                  progress-bar
                                  progress-bar-striped
                                  progress-bar-animated
                                "
                                v-bind:class="{
                                  'bg-success': despachoe.estado != '9',
                                  'bg-light': despachoe.estado == '9',
                                }"
                                role="progressbar"
                                :style="{
                                  width:
                                    (
                                      (detalle.cant_enviada * 100) /
                                      detalle.cant_asignada_estacion
                                    ).toFixed(2) + '%',
                                }"
                              >
                                <a style="color: black"
                                  >{{
                                    (
                                      (detalle.cant_enviada * 100) /
                                      detalle.cant_asignada_estacion
                                    ).toFixed(2)
                                  }}%</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END - Projects list-->
            <div class="table-responsive" v-if="cambiar_UiTabla">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    @click="abrirModalRetornar(det)"
                    v-for="det in despachod"
                    v-bind:key="det.id"
                    v-bind:style="
                      despachoe.estado == '9'
                        ? 'background-color: #f7cdcd;'
                        : det.cant_asignada_estacion == det.cant_enviada &&
                          det.cant_enviada > 0
                        ? 'background-color: #d3ffbf;'
                        : det.cant_asignada_estacion > det.cant_enviada &&
                          det.cant_enviada > 0
                        ? 'background-color: #99ceff;'
                        : det.cant_enviada == 0 &&
                          det.cant_asignada_estacion > 0
                        ? 'background-color: #FFFFF;'
                        : det.cant_asignada_estacion == 0
                        ? 'background-color: #f7cdcd;'
                        : det.cant_asignada_estacion > 0 &&
                          det.cant_enviada == 0
                        ? 'background-color: #FFFFFF;'
                        : 'color: #929292;'
                    "
                  >
                    <td>
                      <div class="value">
                        <small class="font-weight-bold">{{
                          det.producto_id
                        }}</small>
                      </div>
                      <small
                        ><div class="value">
                          {{ det.producto_nombre }}
                        </div></small
                      >
                      Estacionada:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cant_asignada_estacion }}
                        <i
                          v-if="
                            det.cant_pickeada == det.cant_asignada_estacion &&
                            det.cant_asignada_estacion > 0
                          "
                          class="fas fa-check"
                        ></i>
                      </span>
                    </td>
                    <td>
                      <div class="badge badge-info" v-if="det.categoria_nombre">
                        {{ det.categoria_nombre }}
                      </div>
                      <br />
                      Solicitada:
                      <span
                        class="sub-value font-weight-bold"
                        style="color: blue"
                      >
                        {{ det.cantidad_solicitada }}
                      </span>

                      <br />
                      Despachada:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cant_enviada }}
                        <i
                          v-if="
                            det.cant_enviada == det.cant_asignada_estacion &&
                            det.cant_enviada > 0
                          "
                          class="fas fa-check"
                        ></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="retornarProductoDespacho"
      role="dialog"
      tabindex="-1"
      style="padding-right: 15px"
      data-backdrop="static"
      data-keyboard="false"
      href="#"
    >
      <div class="modal-dialog modal-centered fade animated" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            type="button"
            @click="closeModal()"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient">
            <div class="onboarding-title text-center">
              <div
                style="color: #4dbf19"
                v-if="detalle.producto_id"
              >
                {{ detalle.producto_id }} - {{ detalle.producto_nombre }}
              </div>
              <br />
              <span
                style="color: #bf1919; font-size: 16px"
                class="font-weight-bold"
                >Cantidad Despachada:
              </span>
              <span
                style="color: #000000; font-size: 17px"
                class="font-weight-bold"
                >{{ detalle.cant_enviada }}</span
              >
            </div>
            <br />
            <button
              class="btn btn-md btn-danger btn-block"
              @click="generarRetornoPicking()"
            >
              Retornar Producto <br> <i class="fas fa-undo"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      cambiar_UiTabla: false,
      detalle: {},
    };
  },
  props: ["despachod", "despachoe"],
  computed: {},
  mounted() {},
  methods: {
    generarRetornoPicking() {
      let self = this;
      Notifications.alert.confirm(
        "Retornar el producto a la Estación",

        "¿Está Seguro?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.despachoe.id,
            "retorno_producto_despacho",
            {
              producto: self.detalle.producto_id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Retornar Producto a Estación",
                "Realizado Exitosamente"
              );
              self.closeModal();
              self.$emit("refreshDetalle");
            })
            .catch((error) => {
              self.error = error.response.data;
              if (error.response.data && error.response.data.detail) {
                Notifications.alert.error(
                  "Retornar Producto Despachado",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    closeModal() {
      let self = this;
      $("#retornarProductoDespacho").modal("hide");
      self.regresar();
    },
    regresar() {
      let self = this;
      self.detalle = "";
      self.error = "";
    },
    abrirModalRetornar(detalle) {
      this.detalle = detalle;
      $("#retornarProductoDespacho").modal("show");
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
  },
};
</script>
